import {axiosConfigNew as axios} from "../../../utils/axios";

export const apiOneLesson = (data: any) => axios.get(`/edu/ctp/${data}`);
export const apiCtpTypes = (data: any) => axios.get(`/edu/ctp-types`, {
  params: data
});

export const apiLesson = (data: any) => axios.get(`/edu/lesson`, {
  params: data
});

export const apiGetOneLesson = (body: any) => axios.get(`/edu/lesson/${body.lesson_id}`, {
  params: {
    ...(body.student_id ? {student_id: body.student_id} : {})
  }
});

export const apiDeleteOneLesson = (body: any) => axios.delete(`/edu/lesson/${body.lesson_id}`);

export const apiPostPlanTest = (body: any) => axios.post('/sdot/question-answer', body);

export const apiGetPlanTest = (id: any) => axios.get(`/sdot/test/${id}`)

export const apiPostTestProcess = (body: any) => axios.post('/sdot/test-process', body);

export const apiTestImportFromLibrary = (body: any) => axios.get(`/sdot/${body.type}-for-import`, {
  params: body.params,
});

export const apiGetPlanTask = (id: any) => axios.get(`/sdot/task/${id}`);

export const apiGetExamStatement = (id:any) => axios.get(`/sdot/exam-report/${id}`)